import { Navigate, useLocation } from 'react-router';

function PropertyAssociationArea() {
    const location = useLocation();
    const targetPathname = !location.state || !location.state.pathname ? 'assets/' : location.state.pathname.replace(/^\//, '');

    return <Navigate to={{ pathname: targetPathname, search: location.state?.search }} replace />;
}

export default PropertyAssociationArea;
